import { render, staticRenderFns } from "./DeleteClientButton.vue?vue&type=template&id=12a5b900&scoped=true"
import script from "./DeleteClientButton.vue?vue&type=script&lang=js"
export * from "./DeleteClientButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteClientButton.vue?vue&type=style&index=0&id=12a5b900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5b900",
  null
  
)

export default component.exports